<template>
  <div class="system-message">
    <div>{{ text }}</div>
  </div>
</template>

<script>
import IClassroom from '@/components/classroom/lib/IClassroom'

export default {
  data () {
    return {}
  },
  computed: {
    text () {
      if (this.message.data.text) {
        let text = this.message.data.text
        text = text.replace(/{\s*name\s*}/g, IClassroom.user.name)
        return '― ' + text + ' ―'
      }
      return ''
    }
  },
  props: ['message']
}
</script>

<style lang="stylus" scoped>
.system-message {
  width 100%
  text-align center
  font-size 13px
  margin-bottom 1.5rem
  color #888888
}
</style>
